import { Injectable } from '@angular/core';
import { JeevesCustomerActionConfigService, JeevesModalService } from 'gung-standard-jeeves';
import { AuthService, SelectedCustomerService, Customer, GungModalService, NavbarConfigService } from 'gung-standard';
import { Router } from '@angular/router';
import { RefJeevesModalService } from '../ref-jeeves-modal/ref-jeeves-modal.service';
import { first } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportCentralReportService } from 'gung-standard';

@Injectable({
  providedIn: 'root'
})
export class RefJeevesCustomerActionConfigService extends JeevesCustomerActionConfigService {
  base = [
    ...this.base,
    {
      title: 'EDIT_CUSTOMER',
      action: (item: Customer) => {
        this.modalService.openEditCustomerModal(item);
      }
    }
  ];

  constructor(
    protected modalService: RefJeevesModalService,
    protected authService: AuthService,
    protected router: Router,
    protected selectedCustomerService: SelectedCustomerService,
    ngbModal: NgbModal,
    gungModalService: GungModalService,
    navbarConfigService: NavbarConfigService,
    protected reportCentralReportService: ReportCentralReportService
  ) {
    super(modalService, authService, router, selectedCustomerService, ngbModal, gungModalService, navbarConfigService, reportCentralReportService);
  }
}
